//
const replaceHead = function(data){
	const head = document.head;
	const newPageRawHead = data.next.html.match(/]*>([\s\S.]*)<\/head>/i)[0];
	const newPageHead = document.createElement('head');
	newPageHead.innerHTML = newPageRawHead;
	const removeHeadTags = [
	"meta[name='description']"
	,"meta[property^='og']"
	,"meta[name^='twitter']"
	].join(',');
	const headTags = head.querySelectorAll(removeHeadTags)
	for(let i = 0; i < headTags.length; i++ ){
		head.removeChild(headTags[i]);
	}
	const newHeadTags = newPageHead.querySelectorAll(removeHeadTags)
	for(let i = 0; i < newHeadTags.length; i++ ){
		head.appendChild(newHeadTags[i]);
	}
}







//
window.pageTransition = {

	//
	local : null,
	main : null,

	//
	current : {
		name : null,
		url : null,
		layout : null,
		postId : null,
	},
	prev    : {
		name : null,
		url : null,
		layout : null,
		postId : null,
	},
	clone : {
		container : null,
		archive : null
	},

	stagger : !DETECT.device.any ? 0.025 : 0.01,

	anim : {
		ing : false,
		leave : {
			s : 0.6,
			// e : "power1.inOut",
			// e : CustomEase.create("custom", "M0,0,C0.272,0,0.475,0.453,0.496,0.496,0.658,0.83,0.774,0.902,1,1"),
			e : "power1.inOut",
			d : 0,
			power : 0,
			ing : false
		},
		enter : {
			s : !DETECT.device.any ? 0.8 : 0.6,
			// e : "power2.inOut",
			// e : CustomEase.create("custom", "M0,0 C0.09,0.048 0.206,0.108 0.27,0.212 0.351,0.344 0.358,0.362 0.4,0.51 0.443,0.663 0.482,0.832 0.616,0.94 0.691,1 0.832,1 1,1 "),
			e : "power1.inOut",
			d : !DETECT.device.any ? 0.1 : 0.0,
			power : 1,
			ing : false
		}
	},

	mask : {
		el : document.querySelectorAll('.c-mk-bg'),
		leave : {
			tl  : null,
		},
		enter : {
			tl  : null,
		}
	},

	logo : {
		el : document.querySelectorAll('.c-mk .c-m-lg-li'),
		leave : {
			tl  : null,
		},
		enter : {
			tl  : null,
		}
	},

	onLeaveMask( prop = {s : this.anim.leave.s, e : this.anim.leave.e, d : this.anim.leave.d, g : this.stagger } ){
		if( this.mask.leave.tl ) this.mask.leave.tl.kill(); this.mask.leave.tl = null;
		this.mask.leave.tl = gsap.timeline();
		this.mask.leave.tl.fromTo( this.mask.el,{
				y: '100%',
			},
			{
				duration : prop.s - 0.1,
				ease     : prop.e,
				delay    : prop.d + 0.1,
				y: '0%',
			}
		);
	},

	onLeaveLogo( prop = { s : this.anim.leave.s, e : this.anim.leave.e, d : this.anim.leave.d, g : this.stagger } ){
		if( this.logo.leave.tl ) this.logo.leave.tl.kill(); this.logo.leave.tl = null;
		this.logo.leave.tl = gsap.timeline();
		this.logo.leave.tl.fromTo( this.logo.el,{
				y: '200%',
			},
			{
				duration : prop.s,
				ease     : prop.e,
				delay    : prop.d,
				stagger  : prop.g,
				y: '0%',
			}
		);
	},

	onEnterMask( prop = {s : this.anim.enter.s, e : this.anim.enter.e, d : this.anim.enter.d, g : this.stagger } ){
		if( this.mask.enter.tl ) this.mask.enter.tl.kill(); this.mask.enter.tl = null;
		this.mask.enter.tl = gsap.timeline();
		this.mask.enter.tl.to( this.mask.el, {
			y: '-100%',
			duration : prop.s,
			ease     : prop.e,
			delay    : prop.d,
			onComplete : () =>{
				IS_SPLASHED = true;
			}
		});
	},

	onEnterLogo( prop = {s : this.anim.enter.s, e : this.anim.enter.e, d : this.anim.enter.d, g : this.stagger } ){
		if( this.logo.enter.tl ) this.logo.enter.tl.kill(); this.logo.enter.tl = null;
		this.logo.enter.tl = gsap.timeline();
		this.logo.enter.tl.to( this.logo.el, {
			y: '-200%',
			duration : prop.s - prop.g * (this.logo.el.length-1),
			ease     : prop.e,
			delay    : prop.d,
			stagger  : prop.g * -1,
		});
	},

	onInitOnce( elem ){
		this.local = !elem ? document.querySelector('.c-local') : elem;
		this.prev.url = this.current.url;
		this.prev.postId = this.current.postId;
		this.prev.name = this.current.name;
		this.prev.layout = this.current.layout;
		this.current.url = location.href;
		this.current.postId = this.local.dataset.postId;
		this.current.name = this.local.dataset.xhrNamespace;
		this.current.layout = this.local.dataset.layout;
		if( this.prev.name ) $html.dataset.prevPage = this.prev.name;
		if( this.current.name ) $html.dataset.currentPage = this.current.name;
		if( this.prev.layout ) $html.dataset.prevLayout = this.prev.layout;
		if( this.current.layout ) $html.dataset.currentLayout = this.current.layout;
		this.goto.onInit();
	},

	onInit( elem ){

		//
		console.log('pageTransition.onInit - 1');

		//
		this.local = !elem ? document.querySelector('.c-local') : elem;

		//
		this.prev.url = this.current.url;
		this.prev.postId = this.current.postId;
		this.prev.name = this.current.name;
		this.prev.layout = this.current.layout;
		this.current.url = location.href;
		this.current.postId = this.local.dataset.postId;
		this.current.name = this.local.dataset.xhrNamespace;
		this.current.layout = this.local.dataset.layout;

		//
		if( this.prev.name ) $html.dataset.prevPage = this.prev.name;
		if( this.current.name ) $html.dataset.currentPage = this.current.name;
		if( this.prev.layout ) $html.dataset.prevLayout = this.prev.layout;
		if( this.current.layout ) $html.dataset.currentLayout = this.current.layout;

		//
		this.goto.onInit();

		//===
		styleAspect.onInit( elem );
		styleInview.onInit( elem );
		if( styleInviewImage ) styleInviewImage.onInit( elem );
		if( styleInviewVideo ) styleInviewVideo.onInit( elem );
		styleCopy.onInit( elem );
		// styleSlider.onInit( elem );
		styleFilter.onInit( elem );
		styleToggle.onInit( elem );
		styleText.onInit( elem );
		styleMail.onInit( elem );
		styleCss.onInit( elem );
		stylePopup.onInit( elem );
		pageScroll.onInit( elem );

		//===
		if( WEBGL ){
			WEBGL.dom.onDestroy();
			WEBGL.dom.onInit( elem );
			WEBGL.dom.onUpdate();
			WEBGL.logo.onDestroy();
			WEBGL.logo.onInit( elem );
			WEBGL.logo.onResize();
			WEBGL.logo.onEnterAnim({
				s : pageTransition.anim.enter.s * 0.8,
				g : pageTransition.stagger * 0.7,
				d : 0,
				e : 'power2.out'
			});
		}

	},

	onDestroy(){

		console.log('pageTransition.onDestroy');

		//
		this.goto.onDestroy();

		//
		styleInview.onDestroy();
		if( styleInviewImage ) styleInviewImage.onDestroy();
		if( styleInviewVideo ) styleInviewVideo.onDestroy();
		styleCopy.onDestroy();
		// styleSlider.onDestroy();
		styleFilter.onDestroy();
		styleToggle.onDestroy();
		styleText.onDestroy();
		stylePopup.onDestroy();
		pageScroll.onDestroy();

	},

	onLeaveAnim( data ){

		//
		if( styleMenu.isopened ) styleMenu.onClose();

		//
		// this.mask.enter.tl.pause();
		// this.logo.enter.tl.pause();
		// this.mask.leave.tl.restart();
		// this.logo.leave.tl.restart();
		this.onLeaveLogo();
		this.onLeaveMask();

		//
		if( WEBGL ) WEBGL.logo.onLeaveAnim();

		// const $logo = this.local.querySelectorAll('.c-mv .c-lg-svg-li');
		// if( $logo ){
		// 	gsap.to( $logo, {
		// 		y: '-200%',
		// 		duration : this.anim.leave.s,
		// 		ease     : this.anim.leave.e,
		// 		delay    : this.anim.leave.d,
		// 		stagger  : -0.025,
		// 	});
		// }

	},

	onEnterAnim( data ){

		console.log('onEnterAnim');

		//
		// this.mask.leave.tl.pause();
		// this.logo.leave.tl.pause();
		// this.mask.enter.tl.restart();
		// this.logo.enter.tl.restart();
		this.onEnterLogo();
		this.onEnterMask();

		//
		// const $logo = this.local.querySelectorAll('.c-mv .c-lg-svg-li');
		// if( $logo ){
		// 	gsap.set( $logo, { y: '100%' });
		// 	gsap.to( $logo, {
		// 		y: '0%',
		// 		delay    : this.anim.enter.s * 0.5,
		// 		duration : this.anim.enter.s * 1.5,
		// 		ease     : 'expo.out',
		// 		stagger  : 0.05
		// 	});
		// }

	},

	onLeave( data, done ){

		console.log('pageTransition.leave - 0');

		//===
		$html.classList.remove('is-l-back');

		//===
		console.log( this.goto.type );

		//===
		this.onLeaveAnim( data );

		//===
		data.current.container.classList.add('is-l-cnt');
		data.current.container.classList.remove('is-e-cnt');
		gsap.set( this.anim.leave, { power : 0 });
		gsap.to( this.anim.leave, {
			duration : this.anim.leave.s,
			ease     : this.anim.leave.e,
			delay    : this.anim.leave.d,
			power    : 1,
			onStart  : () =>{
				this.anim.ing = true;
				this.anim.leave.ing = true;
				$html.classList.add('is-l-a-e');
				$html.classList.add('is-l-ing');
			},
			onComplete : () =>{
				this.anim.leave.ing = false;
				$html.classList.remove('is-l-ing');
				done();
			}
		});
	},


	onBeforeEnter( data ){
		console.log('pageTransition.onBeforeEnter');
		$html.classList.add('is-e-bfr');
		this.onDestroy();
		window.scroll(0,0);
	},

	onEnter( data ){

		console.log('pageTransition.enter - 0');

		//===
		const elem = data.next.container;

		//===
		this.onInit( elem );

		//===
		this.onEnterAnim( data );

		//===
		data.next.container.classList.add('is-e-cnt');
		data.next.container.classList.remove('is-l-cnt');
		gsap.set( this.anim.enter, { power : 0 });
		gsap.to( this.anim.enter, {
			duration : this.anim.enter.s,
			ease     : this.anim.enter.e,
			delay    : this.anim.enter.d,
			power    : 1,
			onStart  : () =>{
				this.anim.enter.ing = true;
				$html.classList.remove('is-e-bfr');
				$html.classList.add('is-e-ing');
			},
			onComplete : () =>{
				this.anim.ing = false;
				this.anim.enter.ing = false;
				$html.classList.remove('is-l-a-e');
				$html.classList.remove('is-e-ing');
			}
		});

	},

	//
	onLeaveReduce( data, done ){
		done();
	},
	onEnterReduce( data ){
		const elem = data.next.container;
		this.onInit( elem );
		$html.classList.remove('is-e-bfr');
	},

	//
	onLeaveBack( data, done ){
		console.log('pageTransition.onLeaveBack - 0');
		$html.classList.add('is-l-back');
		gsap.set( data.current.container, { opacity : 0 });
		done();
	},
	onEnterBack( data ){
		console.log('pageTransition.onEnterBack - 0');
		const elem = data.next.container;
		this.onInit( elem );
	}

}








pageTransition.once = () =>{

	const _this = pageTransition;
	barba.init({
		timeout: 10000,
		debug : false,
		name: 'overlap',
		// sync: true,
		schema: {
			prefix: 'data-xhr',
		},
		prevent: ({ el }) => el.classList.contains('js-goto-a'),
		transitions: [
			{
				leave(data) {
					const done = this.async();
					if( DETECT.reduced ){
						_this.onLeaveReduce( data, done );
					} else if( DETECT.device.any ){
						if( data.trigger === 'back' || data.trigger === 'forward' ){
							_this.onLeaveBack( data, done );								
						} else {
							_this.onLeave( data, done );
						}
					} else {
						_this.onLeave( data, done );
					}
				},
				beforeEnter(data) {
					_this.onBeforeEnter( data );
				},
				enter( data ) {
					if( DETECT.reduced ){
						_this.onEnterReduce( data );
					} else if( DETECT.device.any ){
						if( data.trigger === 'back' || data.trigger === 'forward' ){
							_this.onEnterBack( data );
						} else {
							_this.onEnter( data );								
						}
					} else {
						_this.onEnter( data );
					}
				}
			}
		]
	});

	barba.hooks.beforeEnter((data) => {
		replaceHead(data);
	});

	//========================
	// PREFETCH
	//========================
	for (let i = 0; i < URLS.length; i++) {
		const v = URLS[i];
		if( v != location.href ){
			setTimeout(()=>{
				barba.prefetch( v );
			}, loadControl.page.s * i + loadControl.page.d );
		}
	}

	//========================
	// REDUCED
	//========================
	if( DETECT.reduced ){
		_this.anim.leave.s = 0;
		_this.anim.leave.e = 'none';
		_this.anim.enter.s = 0;
		_this.anim.enter.e = 'none';
	}

	//
	_this.onInitOnce();

}





